<div class="login-signup-parent-component p-p-3 p-p-md-0 mfa-container splash-screen">
  <div class="p-grid p-nogutter">
    <div class="p-md-11 p-md-offset-1 p-col-12">
      <img
        class="company-logo-login"
        src="../../../../assets/images/IDS-Logo.png"
        alt="IDS - logo"
        />

        <app-message
          [messages]="messages"
          data-qa="messages"
          >
        </app-message>

        <div class="p-grid">
          <div class="p-lg-5 p-md-12">
            <h2 class="multi-authentication-heading">Setup Multi Factor Authentication</h2>
            <div
              class="cms-mfa-content"
              data-qa="mfa-content-header"
              >
              <!-- TODO - Remove WordPress classes and clean up HTML -->
              <p>
                VM Online utilises Multi Factor Authentication (MFA) sign in to ensure that sensitive data
                is securely accessed.
              </p>
              <p>MFA works by using a dedicated app to verify you are the correct person logging in.</p>

              <h2>Download the App</h2>

              <p>Go to your app store and download your preferred Authentication App.</p>

              <p>We recommend:</p>

              <div
                class="wp-block-media-text alignwide is-stacked-on-mobile"
                style="grid-template-columns: 23% auto"
                >
                <figure class="wp-block-media-text__media">
                  <img
                    src="/assets/images/authy.png"
                    alt="Authy"
                    class="wp-image-624"
                    />
                  </figure>
                  <div class="wp-block-media-text__content">
                    <p>
                      Twilio Authy<br />
                      <a
                        href="https://authy.com/guides/twilio/"
                        target="_blank"
                        rel="noreferrer noopener"
                        >Setup Guide</a
                        >
                      </p>
                    </div>
                  </div>

                  <p class="has-text-align-left">or</p>

                  <div
                    class="wp-block-media-text alignwide is-stacked-on-mobile is-vertically-aligned-center"
                    style="grid-template-columns: 23% auto"
                    >
                    <figure class="wp-block-media-text__media">
                      <img
                        src="/assets/images/google-authenticator.png"
                        alt="Google Authenticator"
                        class="wp-image-623"
                        />
                      </figure>
                      <div class="wp-block-media-text__content">
                        <p>
                          Google Authenticator<br />
                          <a
                            href="https://support.google.com/accounts/answer/1066447?co=GENIE.Platform%3DAndroid&amp;hl=en"
                            target="_blank"
                            rel="noreferrer noopener"
                            >Setup Guide</a
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="p-lg-7 p-md-12">
                    <div class="p-grid">
                      <div class="p-lg-4 p-sm-10">
                        <p class="instruction-text">Once installed, follow the following steps</p>

                        <h3 class="setup-mfa-heading">Step 1</h3>

                        <p class="setup-mfa-sub-heading">
                          Scan the QR Code with your authenticator application to associate the token
                        </p>

                        <p class="setup-mfa-sub-heading">
                          If you are unable to scan the QR code,
                          <a
                            class="copy-to-clipboard"
                            (click)="copyToClipboard()"
                            class="bx--tooltip__trigger bx--tooltip--a11y bx--tooltip--bottom bx--tooltip--align-center"
                            >
                            click here to copy
                            <span class="bx--assistive-text">Code: {{ setupTotpCode }}</span>
                          </a>
                          a one time passcode, then paste it into your authenticator application.
                        </p>
                      </div>
                      <div class="p-lg-4 p-sm-10">
                        <form
                          class="login-form qr-code"
                          [formGroup]="setupTotpForm"
                          >
                          @if (qrCode) {
                            <div>
                              <qr-code
                                [value]="qrCode"
                                size="160"
                                errorCorrectionLevel="M"
                                data-qa="qr-code"
                              ></qr-code>
                            </div>
                          }
                        </form>
                      </div>
                    </div>

                    <div
                      class="p-grid"
                      class="setup-step-2"
                      >
                      <div class="p-lg-4 p-sm-10">
                        <div class="setup-mfa-heading">Step 2</div>
                        <div class="setup-mfa-sub-heading">
                          Enter the one time code from the authenticator app to link with VM Online.
                        </div>
                      </div>
                      <div class="p-lg-4 p-sm-10">
                        <form
                          class="login-form code-input"
                          [formGroup]="setupTotpForm"
                          >
                          <app-input-text
                            data-qa="one-time-code-input"
                            displayName="Code"
                            inputId="oneTimeCode"
                            label="One time code"
                            name="oneTimeCode"
                            theme="dark"
                            [formGroup]="setupTotpForm"
                            [maxLength]="maxLength"
                          ></app-input-text>
                        </form>
                      </div>
                      <div class="p-lg-4 p-sm-10 verify-button-container">
                        @if (!isProcessing) {
                          <app-button
                            data-qa="verify-button"
                            [isDisabled]="setupTotpForm.status === 'INVALID'"
                            buttonLabel="Verify"
                            buttonIcon="pi pi-arrow-right"
                            (buttonClicked)="verify()"
                            type="submit"
                            buttonId="verify-submit"
                          ></app-button>
                        }

                        @if (isProcessing) {
                          <img
                            data-qa="loading-indicator"
                            class="spinner p-mt-2"
                            alt="spinning icon showing indicating form is loading"
                            src="../../../assets/images/spinner.svg"
                            />
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
